import React, { useEffect } from "react";
import { Button } from "@mantine/core";
import { HttpClientError } from "../../../providers/HttpClient";
import { queryClient } from "../../../App";
import SurveyList from "../services/model/SurveyList";
import useCloseMultipleSurveyApiService from "../services/api/CloseMultipleSurveyApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type CloseMultipleSurveyButtonProps = {
  surveys: SurveyList[];
};

const CloseMultipleSurveyButton: React.FC<CloseMultipleSurveyButtonProps> = ({
  surveys,
}) => {
  const { isLoading, isError, error, isSuccess, data, mutate } =
    useCloseMultipleSurveyApiService();
  const { showToast } = useToasts();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "survey_close_failed",
        data: {
          message: HttpClientError(error),
        },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({
        strapiId: "survey_close_success",
        data: {
          deleted: data.deleted,
          closed: data.closed,
        },
      });

      queryClient.invalidateQueries(["ListSurveyApiService", 1]).then();
    }
  }, [isSuccess]);

  return (
    <Button
      mr={4}
      variant="outline"
      onClick={() => mutate(surveys.map((it) => it.id))}
      loading={isLoading}
      color="jem-theme"
      loaderPosition="right"
    >
      Close Selected
    </Button>
  );
};

export default CloseMultipleSurveyButton;
